module.exports = __webpack_public_path__ + "img/4.79041996.jpg";